import React, { useEffect, useState } from "react";
import { useRouteMatch } from "react-router-dom";

import { makeStyles } from "@material-ui/styles";

import Execution from "./Execution";
import { getWorkflowBasedOnRequestID } from "../../data/services/API";
import _ from "lodash";
import WolkenSpinner from "../../components/WolkenSpinner";
import DefaultLoader from "../../components/DefaultLoader";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#fafafa", // TODO: Use theme var
    display: "flex",
    paddingLeft: "0",
  },
  body: {
    width: "100vw",
    height: "100vh",
  },
  flexBody: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const OnlyExecutionPage = () => {
  const match = useRouteMatch();

  const classes = useStyles();
  const [workflowId, setWorkflowId] = useState(null);
  // const [workflowId, setWorkflowId] = useState(
  //   "c14da9e8-cce0-4c75-841e-582ba4eaef8f"
  // );
  const [loader, setLoader] = useState(false);

  const fetchWorkFlowDetails = async (requestId) => {
    setLoader(true);
    try {
      const resp = await getWorkflowBasedOnRequestID(requestId);

      if (resp.status === 200) {
        // const data = _.get(resp.data, "results");
        // const workflowId = _.head(data)?.workflowId;
        const workflowId = resp.data;
        if (workflowId) {
          setWorkflowId(workflowId);
          setLoader(false);
        }
      }
    } catch (error) {
      console.log(error.response);
      setWorkflowId(null);
      setLoader(false);
    }
  };

  useEffect(() => {
    let isCancelled = false;

    if (match.params.id) fetchWorkFlowDetails(match.params.id);

    return () => {
      isCancelled = true;
    };
  }, [match.params.id]);

  return (
    <div className={classes.body}>
      {loader ? (
        // <WolkenSpinner />
        <DefaultLoader
          displayModal={loader}
          message="Workflow is getting loaded"
        />
      ) : (
        !_.isNull(workflowId) && (
          <Execution workflowID={workflowId} view="TICKET_SUMMARY" />
        )
      )}
    </div>
  );
};

export default OnlyExecutionPage;
